import * as R from 'ramda'
import moment from 'moment'

export const updateLocale = (locale, formatMessage) => {
  R.unless(
    R.isNil,
    (config) => moment.updateLocale(locale, config),
    createLocaleConfigs(formatMessage),
  )
}

const createLocaleConfigs = (formatMessage) => ({
  relativeTime: {
    future: formatMessage({ id: 'momentConfig.future' }),
    past: formatMessage({ id: 'momentConfig.past' }),
    s: formatMessage({ id: 'momentConfig.s' }),
    m: formatMessage({ id: 'momentConfig.m' }),
    mm: formatMessage({ id: 'momentConfig.mm' }),
    h: formatMessage({ id: 'momentConfig.h' }),
    hh: formatMessage({ id: 'momentConfig.hh' }),
    d: formatMessage({ id: 'momentConfig.d' }),
    dd: function (number) {
      if (number < 7) {
        return formatMessage({ id: 'momentConfig.dd' }, { number }) // Moment uses "d" when it's just 1 day.
      } else {
        var weeks = Math.round(number / 7)
        return weeks === 1
          ? formatMessage({ id: 'momentConfig.w' }, { number: weeks })
          : formatMessage({ id: 'momentConfig.ww' }, { number: weeks })
      }
    },
    M: formatMessage({ id: 'momentConfig.M' }),
    MM: formatMessage({ id: 'momentConfig.MM' }),
    y: formatMessage({ id: 'momentConfig.y' }),
    yy: formatMessage({ id: 'momentConfig.yy' }),
  },
})
